import "./Connect.module.css";
import Header from "@/reusable_sections/Header";
import StartTheConversation from "./sections/StartTheConversation";
import OurHeadquarters from "./sections/OurHeadquarters";
import Footer from "@/reusable_sections/Footer";
export default function ConnectPage() {
  return <div>
      <Header />
      <StartTheConversation />
      <OurHeadquarters />
      <Footer />
    </div>;
}